<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ph">I.</h2>
<p class="calibre3">Galactic Co-ordinator Kimball Kinnison finished his second cup of
Tellurian coffee, got up from the breakfast table, and prowled about
in black abstraction. Twenty-odd years had changed him but little. He
weighed the same, or a few pounds less; although a little of his mass
had shifted downward from his mighty chest and shoulders. His hair was
still brown, his stern face was only faintly lined. He was mature, with
a conscious maturity which no young man can know.</p>
<p class="calibre3">"Since when, Kim, did you think that you could get away with blocking
<i class="calibre9">me</i> out of your mind?" Clarrissa Kinnison directed the thought,
quietly. The years had dealt as lightly with the Red Lensman as with
the Gray. She had been gorgeous, she was now magnificent. "This room is
shielded, you know, against even the girls."</p>
<p class="calibre3">"Sorry, Chris—I didn't mean it that way."</p>
<p class="calibre3">"I know," she laughed. "Automatic. But you've had that block up for two
solid weeks, except when you force yourself to keep it down, and that
means that you're 'way, <i class="calibre9">'way</i> off the beam."</p>
<p class="calibre3">"I've been thinking, incredible as it may seem."</p>
<p class="calibre3">"I know it. Let's have it—cold."</p>
<p class="calibre3">"QX—you asked for it. Queer things have been going on all over.
Inexplicable things ... no apparent reason."</p>
<p class="calibre3">"Such as?"</p>
<p class="calibre3">"Almost any kind of insidious deviltry you care to name. Disaffections,
psychoses, mass hysterias, hallucinations; pointing toward a
Civilization-wide epidemic of revolutions and uprisings for which there
seems to be no basis or justification whatever."</p>
<p class="calibre3">"Why, Kim! How could there be? I haven't heard of anything like that!"</p>
<p class="calibre3">"It hasn't got around. Each solar system thinks that it's a purely
local condition, but it isn't. As Galactic Co-ordinator, with a broad
view of the entire picture, my office would, of course, see such a
thing before anyone else could. We saw it, and set out to nip it in the
bud ... but—" He shrugged his shoulders and grinned wryly.</p>
<p class="calibre3">"But what?" Clarrissa persisted.</p>
<p class="calibre3">"It didn't nip. We sent Lensmen to investigate, but none of them got to
the first check-station. Then I asked our Second-Stage Lensmen—Worsel,
Nadreck, and Tregonsee—to drop whatever they were doing and solve
it for me. They struck it and bounced. They followed, and are still
following, leads and clues galore, but they haven't got a millo's worth
of results so far."</p>
<p class="calibre3">"What? You mean to say it's a problem <i class="calibre9">they</i> can't solve?"</p>
<p class="calibre3">"That they haven't, to date," he corrected, absently. "And that 'gives
me furiously to think'."</p>
<p class="calibre3">"It would," she conceded, "and it also would make you itch to join
them. Think at me, and it'll help you correlate. You should have gone
over the data with me right at first."</p>
<p class="calibre3">"I had reasons not to, as you'll see. But I'm stumped now, so here
goes. We'll have to go away back, to before we were married. First:
Mentor told me, quote, only your descendants will be ready for that
which you now so dimly grope, unquote. Second: you were the only being
ever able to read my thoughts without the aid of the Lens. Third:
Mentor told us, when we asked him if it was QX for us to go ahead that
our marriage was <i class="calibre9">necessary</i>, a choice of phraseology which
bothered you somewhat at the time, but which I then explained as being
in accord with his visualization of the Cosmic All. Fourth: the Patrol
formula is to send the man best fitted for any job to do that job, and
if he can't swing it, to send the Number One graduate of the current
class of Lensmen. Fifth: a Lensman has got to use everything and
everybody available, no matter what or who it is. I used even you, you
remember, in that Lyrane affair and others. Sixth: Sir Austin Cardynge
believed to the day of his death that we were thrown out of that
hyperspatial tube, and out of space, deliberately."</p>
<p class="calibre3">"Well, go on. I don't see much, if any connection."</p>
<p class="calibre3">"You will, if you think of those six points in connection with our
present predicament. Kit graduates next month, and he'll rank Number
One of all Civilization, for all the tea in China."</p>
<p class="calibre3">"Of course. But after all, he's a Lensman. He will insist upon being
assigned to some problem; why not to that one?"</p>
<p class="calibre3">"You don't yet see what that problem is. I've been adding two and two
together for weeks, and can't get any other answer than four. And if
two and two are four, Kit has got to tackle Boskone—the <i class="calibre9">real</i>
Boskone; the one that I never did and very probably never can reach."</p>
<p class="calibre3">"No, Kim—no!" she almost shrieked. "Not Kit, Kim—he's just a boy!"</p>
<p class="calibre3">Kinnison waited, wordless.</p>
<p class="calibre3">She got up, crossed the room to him. He put his arm around her in the
old but ever new gesture.</p>
<p class="calibre3">"Lensman's load, Chris," he said, quietly.</p>
<p class="calibre3">"Of course," she replied then, as quietly. "It was a shock at first,
coming after all these years, but ... if it has to be, it must. But he
doesn't ... surely we can help him, Kim?"</p>
<p class="calibre3">"Surely." The man's arm tightened. "When he hits space I go back to
work. So do Nadreck and Worsel and Tregonsee. So do you, if your kind
of a job turns up. And with us Gray Lensmen to do the blocking, and
with Kit to carry the ball—" His thought died away.</p>
<p class="calibre3">"I'll say so," she breathed. Then: "But you won't call me, I know,
unless you absolutely <i class="calibre9">have</i> to ... and to give up you and
Kit both ... why did we have to be Lensmen, Kim?" she protested,
rebelliously. "Why couldn't we have been ground-grippers? You used to
growl that thought at me before I knew what a Lens really meant—"</p>
<p class="calibre3">"Vell, some of us has got be der first violiners in der orchestra,"
Kinnison misquoted, in an attempt at lightness. "Ve can't all push vind
t'rough der trombone."</p>
<p class="calibre3">"I suppose that's true." The Red Lensman's somber air deepened. "Well,
we were going to start for Tellus today, anyway, to see Kit graduate.
This doesn't change that."</p>
<p class="calibre3">And in a distant room four tall, shapely, auburn-haired, startlingly
identical girls stared at each other briefly, then went <i class="calibre9">en
rapport</i>; for their mother had erred greatly in saying that the
breakfast room was screened against their minds. Nothing was or could
be screened against them: they could think above, below, or, by
sufficient effort, straight through any thought-screen that had ever
been designed. Nothing in which they were interested was safe from
them, and they were interested in practically everything.</p>
<p class="calibre3">"Kay, we've got ourselves a job!" Kathryn, older by minutes than Karen,
excluded pointedly the younger twins, Camilla and Constance—"Cam" and
"Con".</p>
<p class="calibre3">"At last!" Karen exclaimed. "I've been wondering what we were born for,
with nine-tenths of our minds so deep down that nobody except Kit even
knows they're there and so heavily blocked that we can't let even each
other in without a conscious effort. This is it. We'll go places now,
Kat, and really do things."</p>
<p class="calibre3">"What do you mean <i class="calibre9">you'll</i> go places and do things?" Con demanded
indignantly. "Do you think for a second that you've got jets enough to
blast <i class="calibre9">us</i> out of all the fun?"</p>
<p class="calibre3">"Certainly," Kat said, equably. "You're too young."</p>
<p class="calibre3">"We'll let you know what we're doing, though," Kay conceded,
magnanimously. "You might even conceivably contribute an idea that we
could use."</p>
<p class="calibre3">"Ideas—phooey!" Con jeered. "A real idea would crack both of your
skulls. You haven't any more plan than a—"</p>
<p class="calibre3">"Hush—shut up, everybody!" Kat commanded. "This is too new for any of
us to have any worth-while ideas on, yet. Tell you what let's do—we'll
all think this over until we're aboard the <i class="calibre9">Dauntless</i>, halfway to
Tellus; then we'll compare notes and work out parts for all of us."</p>
<p class="calibre3">They left Klovia that afternoon. Kinnison's personal superdreadnought,
the mighty <i class="calibre9">Dauntless</i>—the fourth to bear that name—bored
through intergalactic space. Time passed. The four young redheads
convened.</p>
<p class="calibre3">"I've got it all worked out!" Kat burst out enthusiastically,
forestalling the other three. "There will be four Second-Stage Lensmen
at work and there are four of us. We'll circulate—percolate, you might
say—around and throughout the Universe. We'll pick up ideas and facts
and feed 'em to our Gray Lensmen; surreptitiously, sort of, so they'll
think they got them themselves. I'll take Dad for my partner. Kay can
have—"</p>
<p class="calibre3">"You'll do no such thing!" A general clamor rose, Con's thought
being the most insistent. "If we aren't going to work with all,
indiscriminately, we'll draw lots or throw dice to see who gets him, so
there!"</p>
<p class="calibre3">"Seal it, snake-hips, please," Kat requested, sweetly. "It is trite but
true to say that infants should be seen, but not heard. This is serious
business—"</p>
<p class="calibre3">"Snake-hips! Infant!" Con interrupted, venomously. "Listen, my
steatopygous and senile friend!" Constance measured perhaps a quarter
of an inch less in gluteal circumference than did her oldest sister;
she tipped the beam at one scant pound below her weight. "You and Kay
are a year older than Cam and me, of course; a year ago your minds were
stronger than ours. That condition, however, no longer exists. We, too
are grown up. And to put that statement to test, what can you do that I
can't?"</p>
<p class="calibre3">"This." Kathryn extended a bare arm, narrowed her eyes in
concentration. A Lens materialized about her wrist; not attached to it
by a metallic bracelet, but a bracelet in itself, clinging sentiently
to the smooth, bronzed skin. "I felt that in this work there would be a
need. I learned to satisfy it. Can you match that?"</p>
<p class="calibre3">They could. In a matter of seconds the three others were similarly
enlensed. They had not previously perceived the need, but after Kat had
pointed it out to them by demonstrating the manner of its satisfaction,
their acquisition of full knowledge had been virtually instantaneous.</p>
<p class="calibre3">"Or this, then." Kat's Lens disappeared.</p>
<p class="calibre3">So did the other three. Each knew that no hint of this knowledge or of
this power should ever be revealed; each knew that in any moment of
stress the Lens of Civilization could be and would be hers.</p>
<p class="calibre3">"Logic, then, and by reason, not by chance." Kat changed her tactics.
"I still get Dad. Everybody knows who works best with whom. You, Con,
have tagged around after Worsel all your life. You used to ride him
instead of a horse—"</p>
<p class="calibre3">"She still does," Kay snickered. "He pretty nearly split her in two a
while ago in a seven-gravity pull-out, and she almost broke a toe when
she kicked him for it."</p>
<p class="calibre3">"Worsel is nice," Con defended herself vigorously. "He's more human
than most people, and more fun, as well as having infinitely more
brains. And <i class="calibre9">you</i> can't talk, Kay—what anyone can see in that
Nadreck, so cold-blooded that he freezes you even through armor at
twenty feet—you'll get as cold and hard as he is if you don't—"</p>
<p class="calibre3">"And every time Cam gets within five hundred parsecs of Tregonsee she
goes into silences with him, contemplating raptly the whichnesses of
the why," Kathryn interrupted, forestalling recriminations. "So you
see, by the process of elimination, Dad has got to be mine."</p>
<p class="calibre3">Since they could not all have him it was finally agreed that Kathryn's
claim would be allowed and, after a great deal of discussion and
argument, a tentative plan of action was developed. In due course, the
<i class="calibre9">Dauntless</i> landed upon Tellus. The Kinnisons went to Wentworth
Hall, the towering, chromium-and-glass home of the Tellurian cadets
of the Galactic Patrol. They watched the impressive ceremonies of
graduation. Then, as the new Lensmen marched out to the magnificent
cadences of "Our Patrol," the Gray Lensman, leaving his wife and
daughters to their own devices, made his way to his Tellurian office
in Prime Base.</p>
<p class="calibre3">"Lensman Kinnison, sir, by appointment," his secretary announced, and
as Kit strode in Kinnison stood up and came to attention.</p>
<div class="figcenter1" id="illus2">
<img alt="" class="w" id="id-9065851778182735487" src="Images/img0011.jpg"/>
</div>
<p class="calibre3">"Christopher Kinnison of Klovia, sir, reporting for duty." Kit saluted
crisply.</p>
<p class="calibre3">The Co-ordinator returned the salute punctiliously. Then: "At rest,
Kit. I'm proud of you, mighty proud. We all are. The women want to
heroize you, but I had to see you first, to clear up a few things. An
explanation, an apology, and, in a sense, commiseration."</p>
<p class="calibre3">"An apology, sir?" Kit was dumfounded. "Why, that's unthinkable—"</p>
<p class="calibre3">"For not graduating you in Gray. It has never been done, but that was
not the reason. Your commandant, the Board of Examiners, and Port
Admiral LaForge, all recommended it, agreeing that none of us is
qualified to give you either orders or directions. I blocked it."</p>
<p class="calibre3">"Of course. For the son of the Co-ordinator to be the first Lensman to
graduate Unattached would smell—especially since the fewer who know
of my peculiar characteristics the better. That can wait, sir."</p>
<p class="calibre3">"Not too long, sir." Kinnison's smile was a trifle forced. "Here's
your Release and your kit, and a request signed by the whole Galactic
Council that you go to work on whatever it is that is going on. We
rather think that it heads up somewhere in the Second Galaxy, but that
is little more than a guess."</p>
<p class="calibre3">"I can start out from Klovia, then? Good—I can go home with you."</p>
<p class="calibre3">"That's the idea, and on the way there you can study the situation.
For your information we have made up a series of tapes, carrying not
only all the available data, but also our attempts at analysis and
interpretation. Complete and up to date, except for one item which came
in this morning.... I can't figure out whether it means anything or
not, but it should be inserted—" Kinnison paced the room, scowling.</p>
<p class="calibre3">"Might as well tell me. I'll insert it when I scan the tape."</p>
<p class="calibre3">"QX. I don't suppose that you have heard much about the unusual
shipping trouble we have been having, particularly in the Second
Galaxy?"</p>
<p class="calibre3">"Rumor—gossip only. I'd rather have it straight."</p>
<p class="calibre3">"It's all on the tapes, so I'll give you the barest possible
background. Losses are twenty-five percent above normal. A few highly
peculiar derelicts have been found—peculiar in that they seem to
have been wrecked by madmen. Not only wrecked, but gutted, and with
every mark of identification obliterated. We can't determine even
origin or destination, since the normal disappearances outnumber the
abnormal ones by four to one. On the tapes this is lumped in with
the other psychoses you'll learn about. But this morning they found
another derelict, in which the chief pilot had scrawled 'WARE HELL
HOLE IN SP' across a plate. Connection with the other derelicts, if
any, is obscure. If the pilot was sane when he wrote that message, it
means something—but nobody knows what. If he wasn't, it doesn't, any
more than the dozens of obviously senseless—excuse me, I should say
apparently senseless—messages which we have already recorded."</p>
<p class="calibre3">"Hm-m-m. Interesting. I'll bear it in mind and tape it in its place.
But speaking of peculiar things, I've got one I wanted to discuss with
you—getting my Release was such a shock that I almost forgot it.
Reported it, but nobody thought it was anything important. Maybe ...
probably ... it isn't. Tune your mind up to the top of the range ...
there, did you ever hear of a race that thinks upon that band?"</p>
<p class="calibre3">"I never did—it's practically unreachable. Why—have you?"</p>
<p class="calibre3">"Yes and no. Only once, and that only a touch. Or, rather, a burst; as
though a hard-held mind-block had exploded, or the creature had just
died a violent, instantaneous death. Not enough of it to trace, and I
never found any more of it."</p>
<p class="calibre3">"Any characteristics? Bursts can be quite revealing at times."</p>
<p class="calibre3">"A few. It was on my last break-in trip in the Second Galaxy, out
beyond Thrale—about here." Kit marked the spot upon a mental chart.
"Mentality very high—precisionist grade—possibly beyond social
needs, as the planet was a bare desert. No thought of cities. Nor of
water, although both may have existed without appearing in that burst
of thought. The thing's bodily structure was RTSL, to four places. No
gross digestive tract—atmosphere-nourished or an energy-converter,
perhaps. The sun was a blue giant. No spectral data, of course, but at
a rough guess I'd say somewhere around class B5 or A0. Although the
temperature was normal for him, it was quite evident that the planet
would be unbearably hot for us. That's all I could get."</p>
<p class="calibre3">"That's a lot to get from one burst. It doesn't mean a thing to me
right now—but I'll watch for a chance to fit it in somewhere."</p>
<p class="calibre3">How casually they dismissed as unimportant that cryptic burst
of thought! But if they both, right then, together, had been
authoritatively informed that the description fitted exactly
the physical form forced upon its denizens in its summer by the
accurately-described, simply hellish climatic conditions obtaining
during that season on noxious planet Ploor, the information would still
not have seemed important to either of them—then.</p>
<p class="calibre3">"Anything else we ought to discuss before night?" The older Lensman
went on without a break.</p>
<p class="calibre3">"Not that I know of."</p>
<p class="calibre3">"You said your Release was a shock. Ready for another one?"</p>
<p class="calibre3">"I can't think of a harder one. I'm braced—blast!"</p>
<p class="calibre3">"I have turned the office over to Vice Co-ordinator Maitland for the
duration. I am authorized to tell you that Worsel, Nadreck, Tregonsee,
and I have resumed our Unattached status and, while conducting our own
various investigations, will be holding ourselves ready at all times
for your call."</p>
<p class="calibre3">"That <i class="calibre9">is</i> a shock, sir. Thanks. I hadn't expected ... it's really
overwhelming. And you said something about <i class="calibre9">commiserating</i> me?"
Kit lifted his red-thatched head—all of Clarrissa's children had
inherited her startling hair—and gray eyes stared level into eyes of
gray.</p>
<p class="calibre3">"In a sense, yes. You'll understand later. Well, you'd better go hunt
up Chris and the kids. After the festivities are over—"</p>
<p class="calibre3">"I'd better cut them, hadn't I?" Kit asked, eagerly. "Don't you think
it'd be better for me to get started right away?"</p>
<p class="calibre3">"Not on your life!" Kinnison demurred, positively. "Do you think that I
want that mob of strawberry blondes to snatch me bald-headed? You're in
for a large day and evening of lionization, so take it like a man. As I
was about to say, as soon as the brawl is over tonight we'll all board
the <i class="calibre9">Dauntless</i> and do a flit for Klovia, where I'll fit you out
with everything you want. Until then, son—" Two big hands gripped.</p>
<p class="calibre3">"But I'll be seeing you around the Hall!" Kit exclaimed. "You can't—"</p>
<p class="calibre3">"No, I can't dodge the lionizing, either," Kinnison grinned, "but we
won't be in a sealed and shielded room. So, son ... I'm proud of you."</p>
<p class="calibre3">"Right back at you, big fellow—and thanks a million." Kit strode out
and, a few minutes later, the Co-ordinator did likewise.</p>
<p class="calibre3">The "brawl," which was the gala event of the Tellurian social year,
was duly enjoyed by all the Kinnisons. The <i class="calibre9">Dauntless</i> made an
uneventful flight to Klovia. Arrangements were made. Plans, necessarily
sketchy and elastic, were laid.</p>
<p class="calibre3">Two big, gray-clad Lensmen stood upon the deserted spacefield, between
two blackly indetectable speedsters. Kinnison was massive, sure, calm
with the poised calmness of maturity, experience, and power. Kit, with
the broad shoulders and narrow waist of his years and training, was
taut and tense, fiery, eager to come to grips with Civilization's foes.</p>
<p class="calibre3">"Remember, son," Kinnison said as the two gripped hands. "There are
four of us old-timers, who have been through the mill, on call every
second. If you can use any one of us or all of us, don't wait to be too
sure—snap out a call."</p>
<p class="calibre3">"I know, Dad ... thanks. The four best, ablest Lensmen that ever
lived. One of you may make a strike before I do. In fact, with the
thousands of leads we have, and with no way of telling how many of them
are false—deliberately or otherwise—and with your vastly greater
experience and knowledge, you probably will. So remember that it cuts
both ways. If any of you can use me at any time, I'll come at max."</p>
<p class="calibre3">"QX. We'll get in touch from time to time, anyway. Clear ether, Kit!"</p>
<p class="calibre3">"Clear ether, Dad!" What a wealth of meaning there was in that
low-voiced, simple exchange of the standard bon voyage!</p>
<p class="calibre3">For minutes, as his speedster flashed through space, Kinnison thought
only of the boy. He knew exactly how he felt; he relived in memory
the supremely ecstatic moments of his own first launching into space
as a Gray Lensman. But Kit had the stuff—stuff which he, Kinnison,
knew that he could know nothing about—and he had his own job to do.
Therefore, methodically, like the old campaigner he was, he set about
it.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?40a6d29e